import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Google Dinosaur"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-google-dinosaur',
    templateUrl: './icon-google-dinosaur.component.html',
    styleUrls: ['./icon-google-dinosaur.component.scss'],
    standalone: false
})
export class IconGoogleDinosaurComponent {
  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
